import { useCallback } from 'react';

import { FabricChannel } from '@atlaskit/analytics-listeners';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export type OperationalEvent = {
	action: string;
	actionSubject: string;
	actionSubjectId?: string;
	attributes: Record<string, any>;
};

//Custom hook to fire an event for polling, to be used in PollingForUpgrade file
export function useOperationalAnalytics({
	product,
	edition,
}: {
	edition: string;
	product: string;
}): (event: OperationalEvent) => void {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return useCallback(
		({ action, actionSubject, actionSubjectId, attributes }: OperationalEvent) => {
			const event = createAnalyticsEvent({
				eventType: 'operational',
				action,
				actionSubject,
				actionSubjectId,
				attributes: {
					product,
					targetEdition: edition,
					...attributes,
				},
			});
			event.fire(FabricChannel.growth);
		},
		[createAnalyticsEvent, product, edition],
	);
}
